import "../../components/Testimonial/Testimonial.css"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import quote1 from "../../images/quote-test.svg"
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from "react";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config";


function Testimonial({free_test_slug }) {

   const [TestimonialData, setTestimonialData] = useState(null);

   const [visible, setVisible] = useState(false);

    useEffect(() => {

        axios
            .get(`${END_URL}/archetypal/testimonial`)
            .then((res) => {

                setTestimonialData(res.data);

                requestAnimationFrame(() => {
                    setVisible(true);
                });
            })
            .catch((err) => {
                console.error(err);
            });

    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
         autoplay: true,
         autoplaySpeed: 3000,
         pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const testimonialIndexes = [1, 2, 3, 4,5,6,7];

    if (!TestimonialData) {
        return (
            <div className="test-sect test-loader">
                <div className="container">
                    <div className="section-loader"></div>
                </div>
            </div>
        );
    }

    return (

        <div className={`test-sect test-sect-home testimonial-transition ${ visible ? "show" : "" }`}>

            <div className="container">

                <div className="row test-title-row testimo-title-row testimonial-title">

                    <span><img  decoding="async" loading="lazy"  src={`${IMG_URL}/d0/${TestimonialData?.testi_banner_image}`} alt={TestimonialData?.testi_banner_image_alt} /></span> <h3>{TestimonialData?.testimonial_title}</h3>

                </div>

                <div className="row test-slider-row testimonial-slider">

                    <Slider {...settings}>

                        {testimonialIndexes.map((i) => (
                            <div className="test-card" key={i}>
                                <div className="test-quote">
                                <img loading="lazy" decoding="async" src={quote1} alt="quote" />
                                </div>
                                <div className="test-content">
                                <div
                                    dangerouslySetInnerHTML={{
                                    __html: TestimonialData?.[`reviewdescription${i}`],
                                    }}
                                />
                                </div>
                                <div className="test-name">
                                <div>
                                    { TestimonialData?.[`reviewname${i}`] ? (
                                        
                                        <p dangerouslySetInnerHTML={{__html:TestimonialData?.[`reviewname${i}`]}}/>

                                    ) :(

                                        <p style={{ opacity: "0" }}>no content <span>add user</span> </p>
                                    )
                                }

                                    <img loading="lazy" decoding="async" src={`${IMG_URL}/d0/${TestimonialData?.[`archetype_logo_${i}`]}`} alt="line" />

                                </div>

                                <span>

                                    <img loading="lazy" decoding="async"
                                    src={`${IMG_URL}/d0/${TestimonialData?.[`reviewimage${i}`]}`}

                                    alt={TestimonialData?.[`reviewimage${i}_alt`]}
                                    />

                                </span>

                                </div>
                            </div>
                        ))}
                        
                    </Slider>


                </div>


            </div>

            <div className="container">
                <div className="row test-cta testimonial-cta">
                    <div className="col-12 col-md-12">
                        <div className="arch-bottom-btn">

                            <p dangerouslySetInnerHTML={{ __html: TestimonialData?.testimonial_discover_title }} />

                            <a
                                className="home-slider-sun-box-a"
                                href={`/${free_test_slug}`}
                                rel="noopener noreferrer"
                            >
                                <span className="home-slider-sun-box-a-text"> {TestimonialData?.testimonial_discover_btn}</span>
                                <span className="home-slider-sun-box-a-icon">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    )
}

export default Testimonial